"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlledMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var MenuOpener_1 = require("./menuOpener/MenuOpener");
var ControlledMenu = /** @class */ (function (_super) {
    tslib_1.__extends(ControlledMenu, _super);
    function ControlledMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.closeMenu = function () {
            _this.props.onOpenedChange({ opened: false, source: "SCROLL" });
        };
        _this.addScrollListeners = function () {
            window.addEventListener("scroll", _this.closeMenu, true);
        };
        _this.removeScrollListeners = function () {
            window.removeEventListener("scroll", _this.closeMenu, true);
        };
        return _this;
    }
    ControlledMenu.prototype.componentDidMount = function () {
        if (this.props.closeOnScroll) {
            this.addScrollListeners();
        }
    };
    ControlledMenu.prototype.componentWillUnmount = function () {
        if (this.props.closeOnScroll) {
            this.removeScrollListeners();
        }
    };
    ControlledMenu.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.closeOnScroll !== this.props.closeOnScroll) {
            if (this.props.closeOnScroll) {
                this.addScrollListeners();
            }
            else {
                this.removeScrollListeners();
            }
        }
    };
    ControlledMenu.prototype.render = function () {
        return (react_1.default.createElement(MenuOpener_1.MenuOpener, { opened: this.props.opened, onOpenedChange: this.props.onOpenedChange, openAction: this.props.openAction, alignment: this.props.alignment, spacing: this.props.spacing, offset: this.props.offset, portalTarget: this.props.portalTarget, toggler: this.props.toggler, togglerWrapperClassName: this.props.togglerWrapperClassName, topLevelMenu: true }, this.props.children));
    };
    return ControlledMenu;
}(react_1.default.Component));
exports.ControlledMenu = ControlledMenu;
//# sourceMappingURL=ControlledMenu.js.map